import { createSlice } from "@reduxjs/toolkit";


const nameSlice = createSlice({
    name:'Global',
    initialState:{
        IndexNumberList:[//首页数字滚动变化
            {
                code:'1',
                number:'20',
                icon:require('@/assets/home/press1.png'),
                bgImg:require('@/assets/home/press1-bg.png'),
                unit:'+年',
                title:'专注服务器领域',
            },
            {
                code:'2',
                number:'100',
                icon:require('@/assets/home/press2.png'),
                bgImg:require('@/assets/home/press2-bg.png'),
                unit:'+',
                title:'自主专利技术',
            },
            {
                code:'3',
                number:'1',
                icon:require('@/assets/home/press3.png'),
                bgImg:require('@/assets/home/press3-bg.png'),
                unit:'个',
                title:'超大型研发中心',
            },
            {
                code:'7',
                number:'12000',
                icon:require('@/assets/home/press7.png'),
                bgImg:require('@/assets/home/press7-bg.png'),
                unit:'+㎡',   
                title:'生产基地',
            },
            {
                code:'4',
                number:'70000',
                icon:require('@/assets/home/press4.png'),
                bgImg:require('@/assets/home/press4-bg.png'),
                unit:'+',
                title:'GPU服务器在保量',
            },
            {
                code:'5',
                number:'50',
                icon:require('@/assets/home/press5.png'),
                bgImg:require('@/assets/home/press5-bg.png'),
                unit:'+',
                title:'世界IT500强供应商',
            },
            {
                code:'6',
                number:'1500',
                icon:require('@/assets/home/press6.png'),
                bgImg:require('@/assets/home/press6-bg.png'),
                unit:'+',
                title:'企事业单位客户',
            },

            {
                code:'8',
                number:'600',
                icon:require('@/assets/home/press8.png'),
                bgImg:require('@/assets/home/press8-bg.png'),
                unit:'+',
                title:'企业员工数量',
            },                        
        ],     
        AIList:[//AI服务器
            {
                center:'AI服务器',
                iconUrl: require("@/assets/AI/AI-banner.webp"),
                content:'AI Server'
            }
        ],
        AIproductServiceList:[//AI服务器-产品与服务
            {
                header:'异构加速',
                iconUrl:require("@/assets/AI/SaaS-1.webp"),
                icon:require("@/assets/AI/SaaS-1.png"),
                content:'多元异构芯片提升智能算力，支持高强度GPU计算'
            },
            {
                header:'高度融合',
                iconUrl:require("@/assets/AI/SaaS-2.webp"),
                icon:require("@/assets/AI/SaaS-2.png"),
                content:'性能、密度、扩展高度融合 ，提升部署密度和空间使用率， 降低TCO'
            },
            {
                header:'绿色节能',
                iconUrl:require("@/assets/AI/SaaS-3.webp"),
                icon:require("@/assets/AI/SaaS-3.png"),
                content:'绿色节能设计，高效制冷；针对GPU不同运行特性和环境提供优化的散热模式'
            },
        ],
        AISolutionList:[//AI服务器-方案精选
            {
                header:'气候现象智能预测AI服务器方案',
                link:'/solution/1891',
                iconUrl:require("@/assets/AI/AISolution-1.webp"),
                content:'在应对气候变化方面，人工智能具有广阔的应用空间并将发挥越来越重要'
            },
            {
                header:'信维IT解决方案助力自动驾驶算法模型优化',
                link:'/solution/1889',
                iconUrl:require("@/assets/AI/AISolution-2.webp"),
                content:'自动驾驶是一种使用计算机技术和传感器等设备使汽车或其他交通工具能'
            },
            {
                header:'人工智能步态识别硬件方案',
                link:'/solution/1887',
                iconUrl:require("@/assets/AI/AISolution-3.webp"),
                content:'步态识别是一种新的生物特征识别技术，它旨在根据人们的走路姿势实现'
            },
            
        ],
        NEWCompanyList:[//新闻中心-公司新闻
            {
                center:'公司新闻',
                iconUrl: require("@/assets/News/Industry-banner.webp"),
                content:'Company News'
            }
        ],
        NEWIndustryList:[//新闻中心-行业新闻
            {
                center:'行业新闻',
                iconUrl: require("@/assets/News/Industry-banner.webp"),
                content:'Industry News'
            }
        ], 
        AboutCompanyList:[//关于信维-公司简介
            {
                center:'公司简介',
                iconUrl: require("@/assets/About/intro-banner.webp"),
                content:'Company Profile'
            }
        ],
        AboutUsList:[//关于信维-联系我们
            {
                center:'联系我们',
                iconUrl: require("@/assets/About/us-banner.webp"),
                content:'Contact Us'
            }
        ], 
        AboutHonorsList:[//关于信维-荣誉资质
            {
                center:'荣誉资质',
                iconUrl: require("@/assets/About/Honors-banner.webp"),
                content:'Honors and Qualifications'
            }
        ],
        // AboutInvestorRelationsList:[//关于信维-投资者关系
        //     {
        //         center:'投资者关系',
        //         iconUrl: require("@/assets/About/Investor-banner.webp"),
        //         content:'Investor Relations'
        //     }
        // ],
        AboutVideoShowList:[//关于信维-视频展示
            {
                center:'视频展示',
                iconUrl: require("@/assets/About/video-banner.webp"),
                content:'Video Showcase'
            }
        ],
        // AboutEmployeeProfileList:[//关于信维-员工风采
        //     {
        //         center:'员工风采',
        //         iconUrl: require("@/assets/About/Employee-banner.webp"),
        //         content:'Employee Profiles'
        //     }
        // ],
        CorporateBusinessList:[//公司业务
                        {
                            center:'生产制造',
                            iconUrl: require("@/assets/Services/Manufacturing-banner.webp"),
                            content:'Manufacturing'
                        },
                        {
                            center:'供应链服务',
                            iconUrl: require("@/assets/Services/Supply-banner.webp"),
                            content:'Supply Chain Services'
                        },
                        {
                            center:'售后与运维',
                            iconUrl: require("@/assets/Services/Maintenance-banner.webp"),
                            content:'After-sales and Operations & Maintenance'
                        },
                        {
                            center:'利旧改配服务',
                            iconUrl: require("@/assets/Services/Refurbishment-banner.webp"),
                            content:'Refurbishment and Reconfiguration Services'
                        },
                        {
                            center:'设计研发中心',
                            iconUrl: require("@/assets/Services/Design-banner.webp"),
                            content:'Design and R&D Center'
                        }

        ],
        AboutCoreBusinessData:[//五大核心业务数据
            {
                title:'研发设计',
                bgImage:require("@/assets/About/core-1.webp"),
                closeDescription:'与英业达合资成立的重庆（顺维）研发中心总面积10,000平米。研发方向为：x86服务器、边缘计算服务器、存储服务器、AI服务器及数据中心解决方案。拥有一支经验丰富的研发团队，致力于为客户提供高性能、高可靠性的服务器产品和解决方案。',
                openDescription:'与英业达合资成立的重庆（顺维）研发中心总面积10,000平米。研发方向为：x86服务器、边缘计算服务器、存储服务器、AI服务器及数据中心解决方案。拥有一支经验丰富的研发团队，致力于为客户提供高性能、高可靠性的服务器产品和解决方案。'
            },
            {
                title:'生产制造',
                bgImage:require("@/assets/About/core-2.webp"),
                closeDescription:'拥有先进的生产制造基地，具备完整的服务器生产线和质量控制体系。采用精益生产管理，确保产品质量和交付效率，年产能达到数十万台服务器。',
                openDescription:'拥有先进的生产制造基地，具备完整的服务器生产线和质量控制体系。采用精益生产管理，确保产品质量和交付效率，年产能达到数十万台服务器。'
            },
            {
                title:'销售服务',
                bgImage:require("@/assets/About/core-3.webp"),
                closeDescription:'建立了覆盖全国的销售和服务网络，为客户提供专业的技术支持和售后服务。拥有一支专业的销售团队和技术支持团队，能够快速响应客户需求，提供定制化解决方案。',
                openDescription:'建立了覆盖全国的销售和服务网络，为客户提供专业的技术支持和售后服务。拥有一支专业的销售团队和技术支持团队，能够快速响应客户需求，提供定制化解决方案。'
            },
            {
                title:'供应链管理',
                bgImage:require("@/assets/About/core-4.webp"),
                closeDescription:'建立了完善的供应链管理体系，与国内外知名供应商建立了长期稳定的合作关系，确保原材料的稳定供应和产品质量。采用先进的供应链管理系统，实现了供应链的可视化和智能化管理。',
                openDescription:'建立了完善的供应链管理体系，与国内外知名供应商建立了长期稳定的合作关系，确保原材料的稳定供应和产品质量。采用先进的供应链管理系统，实现了供应链的可视化和智能化管理。'
            },
            {
                title:'解决方案',
                bgImage:require("@/assets/About/core-5.webp"),
                closeDescription:'为客户提供从服务器到数据中心的全系列解决方案，包括AI算力解决方案、边缘计算解决方案、云计算解决方案等。能够根据客户需求，提供定制化的解决方案，帮助客户实现数字化转型和业务增长。',
                openDescription:'为客户提供从服务器到数据中心的全系列解决方案，包括AI算力解决方案、边缘计算解决方案、云计算解决方案等。能够根据客户需求，提供定制化的解决方案，帮助客户实现数字化转型和业务增长。'
            }
        ],
    },
    reducers:{
        changeState(state,{payload}){
            // 使用 Object.assign 或者直接赋值来更新 state
            Object.assign(state, payload);
            // 或者使用展开运算符的方式（推荐）
            // return { ...state, ...payload };
        }
    }
})
export const getters = (state)=>{
    console.log('++++++++++++',state)
    return state.Global
}
export const {changeState} = nameSlice.actions
export default nameSlice.reducer
